import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import MenuItems from "./MenuItems";

const MenuHandler = ({ setSelectedKeys, setOpenKeys }) => {
  const location = useLocation();
  const menuItems = MenuItems();
  useEffect(() => {
    const pathAfterAdmin = location.pathname.split("corporate/")[1];
   if (pathAfterAdmin) {
      let selectedKey = "";
      let openSubMenu = [];
    const findMenuKey = (path, items, parentKeys = []) => {
        for (const item of items) {
          if (item.label?.props?.to?.pathname === path) {
            selectedKey = item.key;
            openSubMenu = parentKeys;
            return true; // Found the correct menu item
          }
          if (item.children) {
            const found = findMenuKey(path, item.children, [
              ...parentKeys,
              item.key,
            ]);
            if (found) return true; // Stop searching if found
          }
        }
        return false; // Continue searching if not found
      };

      findMenuKey(pathAfterAdmin, menuItems);

      if (selectedKey) {
        setSelectedKeys([selectedKey]);
        setOpenKeys(openSubMenu);
      }
    }
  }, [location, setSelectedKeys, setOpenKeys]);

  return null;
};

export default MenuHandler;
